var $ = require('jquery');
var angular = require('angular');
var l10n = require('diy/util/l10n').getString;
var infoDialogApi = require('diy/info-dialog/InfoDialogApi');
var pagesEditorObserver = require('diy/externalwebsiteimport/NotifierObservers/PagesEditorObserver').pagesEditorObserver;

/**
 * Class for Pages item in site-admin
 *
 * @class pagesEditor
 * @depends controller.js
 * @author Marian COJOC
 */

(function() {

    this.controllerLoaded = false;
    this.isHidden = true;
    var currentPageStartIndex = null;
    var navigationDataLoaded = false;
    var currentPageId =  null;
    var getCurrentPageId = function()
    {
        if (currentPageId === null) {
            currentPageId = parseInt(jQuery('body').attr('data-pageId'), 10);
        }
        return currentPageId;
    };
    /**
     *
     * @param contentElement TODO: fill this
     */
    this.afterFillContent = function(el, payload, contentElement) {
        diy.editor.siteadmin.api.updateTitle(jimdoData.messages.pagesEditor.window.title);
        diy.editor.siteadmin.api.updateDescr(jimdoData.messages.pagesEditor.window.description);

        diy.editor.siteadmin.api.updateButtons({});
        diy.editor.siteadmin.api.updateNavi({});
        diy.editor.siteadmin.api.updateHelpTopic('navigation');
        diy.editor.siteadmin.api.updateFeatureGuidanceHelp('managePages');
        jQuery(document).bind('diy-editor-managePageFromNavigation', {}, function(e, data) {
            if (data.actionName == 'AddPage') {
                diy.editor.siteadmin.api.updateFeatureGuidanceHelp('managePages');
            }
        });
        jQuery(document).bind('diy-editor-selectPageFromNavigation', {}, function(e, data) {
            if (data.actionName == 'SelectPage') {
                diy.editor.siteadmin.api.updateFeatureGuidanceHelp();
            }
        });

        var successFn = function() {
            var app = angular.module('pagesEditor', ['ngResource', 'ngSanitize']);

            diy.angular.loadControllers(app, [
                'pagesEditor.main',
                'pagesEditor.details',
                'pagesEditor.usecaseSelector',
                'pagesEditor.navigation'
            ]);

            diy.angular.loadFactories(app, [
                'diyl10n',
                'pagesEditor.diyprojecttype',
                'pagesEditor.usecases',
                'pagesEditor.pageinformation',
                'pagesEditor.websiteseodefaults',
                'pagesEditor.navigationdata',
                'pagesEditor.semanticdatafeature',
                'pagesEditor.touchhelper'
            ]);

            diy.angular.loadFilters(app, [
                'pagesEditorUsecasecategory',
                'pagesEditorEmphasekeywords'
            ]);

            diy.angular.loadDirectives(app, [
                 //general directives
                'diybutton',
                'diycheckbox',
                'diyradio',
                'diyreversedcheckbox',
                'diyquickhelp',
                'diymessage',
                'diyautogrow',

                 //app specific directives
                'pagesEditor.usecase',
                'pagesEditor.tree',
                'pagesEditor.treeNode'
            ]);
            var appElement = contentElement.find('.pages-editor');
            angular.bootstrap(appElement, ['pagesEditor']);
            localMainScope = angular.element(appElement).scope();

            localMainScope.$on('navigationDataLoaded', function(){
                navigationDataLoaded = true;
                registerCurrentPageIndex();
            });
            jQuery(document).bind('diy-navigation-loading-status', updateLoadingStatus);
            jQuery(document).trigger('diy-navigation-ngapp-loaded');

            // broadcast the display of notifications
            localMainScope.$apply(function () {
                localMainScope.$broadcast('showNotifications', getNotifications());
            });

            localMainScope.$on('showPageDeletionLimitWarning', function(event, withoutSubPages) {
                showPageDeletionLimitWarning(withoutSubPages, localMainScope);
            });
        };

        var errorFn = function() {
            // TODO
            alert('TODO error handling');
        };
        diy.util.scriptLoader(payload.data.js, successFn, errorFn);

        //tracking events
        jQuery(document.body).trigger('NavigationEditorOpened.BSA');
        this.controllerLoaded = true;
    };
    var registerCurrentPageIndex = function()
    {
        currentPageStartIndex = diy.editor.navigation.api.getPageIndex(
            getCurrentPageId()
        );
    };
    this.show = function() {
        this.isHidden = false;

        //show the click-catcher overlay
        var $overlay = jQuery(
            '<div id="siteadmin-window-overlay-pagesEditor" class="diye ui-overlay">'
                +'<div class="ui-widget-overlay transparent" style="z-index:49001; position: fixed;"></div>'
                +'</div>'
        ).hide().appendTo('body');
        $overlay.bind('click', function(){
            diy.editor.siteadmin.api.close();
        });
        $overlay.show();

        //make the next persistance request be special because it's the first
        //..after the user opened the pages-editor
        diy.editor.navigation.api.setFirstTime(true, function(){
            if (diy.editor.undoRedo) {
                diy.editor.undoRedo.hideRedoQueue();
            }
        });
        if (navigationDataLoaded == true) {
            registerCurrentPageIndex();
        }
        //trigger a digest cycle..
        //XXX: maybe block the interface with a loading screen until this finishes
        if (localMainScope !== null) {
            localMainScope.refreshActivePage();

            // broadcast that the SA window is showing //
            localMainScope.$broadcast('windowShow');

            // broadcast the display of notifications
            localMainScope.$apply(function () {
                localMainScope.$broadcast('showNotifications', getNotifications());
            });
        }
        jQuery(document).trigger('diy-managepages-show');
    };

    var getNotifications = function () {
        var notifications = [];

        if (pagesEditorObserver.isDeclined() && ! pagesEditorObserver.isRemoved()) {
            var message = pagesEditorObserver.getMessage();

            if (typeof message !== 'undefined') {
                notifications.push({
                    title: message.title,
                    text: message.message,
                    action: function() {
                        diy.editor.siteadmin.api.close();
                        message.actionHandler();
                    },
                    actionText: message.actionText
                });
            }
        }
        return notifications;
    };

    var showPageDeletionLimitWarning = function(withoutSubPages, localMainScope) {
        infoDialogApi.showDialog(
            {
                status: 'error',
                title: l10n('pagesEditor.limitReached.title'),
                description: l10n("pagesEditor.limitReached.description").replace(
                    "{5}",
                    jimdoData.navigation.maximumLimit
                ).replace(
                    "{link}",
                    '<a href="#" id="cc-sa-item-updateTariff" onclick="">' + l10n('pagesEditor.limitReached.link') + '</a>'
                ),
                primaryButtonConfig: {
                    label: l10n('pagesEditor.limitReached.close')
                },
                secondaryButtonConfig: {
                    label: l10n('pagesEditor.limitReached.delete'),
                    callback: function () {
                        localMainScope.$broadcast("deletePage", withoutSubPages);
                    }
                }
            }
        );
    };

    var confirmBoxHtml = '<div><div class="pe-dialog-box-wrapper with-icon">' +
        '<div class="ui-icon ui-icon-alert"></div>' +
        '<div class="pe-dialog-box-title"></div>' +
        '<div class="pe-window-loading"><div class="rotate-animation"></div></div>' +
        '<div class="pe-dialog-box-description"></div>' +
        '<div class="pe-dialog-box-extra"></div>' +
        '</div></div>';

    //TODO: this part needs to be refactor so we don't have anymore duplicate lines with diffrent css.
    var msgUseCasePending = '<hr />' +
        '<h2 class="working use-case-confirmation-step-preparing"><div class="pe-icon pe-icon-fail"></div>' + jimdoData.messages.pagesEditor.usecase.dialogBox.preparing + '</h2>' +
        '<h2 class="use-case-confirmation-step-preparing-finished"><div class="pe-icon pe-icon-ok"></div>' + jimdoData.messages.pagesEditor.usecase.dialogBox.preparing + '</h2>' +
        '<h2 class="use-case-confirmation-step-import"><div class="pe-icon pe-icon-fail"></div>' + jimdoData.messages.pagesEditor.usecase.dialogBox.importing + '</h2>' +
        '<h2 class="use-case-confirmation-step-import-finished"><div class="pe-icon pe-icon-ok"></div>' + jimdoData.messages.pagesEditor.usecase.dialogBox.importing + '</h2>' +
        '<h2 class="use-case-confirmation-step-publishing"><div class="pe-icon pe-icon-fail"></div>' + jimdoData.messages.pagesEditor.usecase.dialogBox.publishing + '</h2>';

    var diyConfirmBox = null;
    var localMainScope = null;

    var diyConfirmBoxButtons = {
        okButton: {
            text: jimdoData.messages.pagesEditor.dialogBox.ok,
            click: function () {
                diy.editor.navigation.api.notify('force_update');
                releaseConfirmBox();
            }
        }
    };

    var releaseConfirmBox = function ()
    {
        if (diyConfirmBox != null) {
            diyConfirmBox.remove();
            diyConfirmBox = null;
        }
    };

    var statusDialog = function (title, description, appendix)
    {
        releaseConfirmBox();
        diyConfirmBox = jQuery(confirmBoxHtml);

        diyConfirmBox.find('.pe-dialog-box-title').html(title);
        diyConfirmBox.find('.pe-dialog-box-description').html(description);
        diyConfirmBox.find('.pe-dialog-box-extra').html(appendix);

        diyConfirmBox.diy_confirmationDialog({
            zIndex: 100210,
            closeOnEscape: false,
            overlayCls: null, /* use default semi-transparent overlay */
            width: 386,
            position: {
                my: 'center middle',
                at: 'center middle'
            },
            buttons: []
        });
        diyConfirmBox.find('.pe-window-loading').show();
    };

    var statusPrepareDescription = function (eventData)
    {
        var description = '';
        if (eventData.useCaseDetails.crawlerUrl) {
            description = (jimdoData.messages.pagesEditor.usecase.dialogBox.descriptionMainImportCrawledContent);
            description = description.replace('{site_url}', eventData.useCaseDetails.crawlerUrl);
        } else {

            if (eventData.useCaseDetails.pageCount > 1) {
                description = (jimdoData.messages.pagesEditor.usecase.dialogBox.descriptionMainWithSubPages);
                description = description.replace('{number_of_subpages}', parseInt(eventData.useCaseDetails.pageCount) - 1);
            } else {
                description = (jimdoData.messages.pagesEditor.usecase.dialogBox.descriptionMainWithoutSubPages);
            }

            description = description.replace('{page_title}', eventData.useCaseDetails.name);
        }
        return description;
    };


    var statusDialogStart = function (eventData)
    {
        var description = statusPrepareDescription(eventData);

        statusDialog(jimdoData.messages.pagesEditor.usecase.dialogBox.title, description, msgUseCasePending);
    };

    var statusDialogImporting = function(eventData)
    {
        if (diyConfirmBox == null) {
            statusDialogStart(eventData);
        }
        diyConfirmBox.find('.use-case-confirmation-step-preparing').removeClass('working');
        diyConfirmBox.find('.use-case-confirmation-step-preparing-finished').show();
        diyConfirmBox.find('.use-case-confirmation-step-import').addClass('working');
    };

    var statusDialogImported = function(eventData)
    {
        if (diyConfirmBox == null) {
            statusDialogStart(eventData);
        }
        diyConfirmBox.find('.use-case-confirmation-step-preparing').removeClass('working');
        diyConfirmBox.find('.use-case-confirmation-step-preparing-finished').show();
        diyConfirmBox.find('.use-case-confirmation-step-import').removeClass('working');
        diyConfirmBox.find('.use-case-confirmation-step-import-finished').show();
        diyConfirmBox.find('.use-case-confirmation-step-publishing').addClass('working');
    };

    var statusDialogError = function(eventData)
    {
        if (diyConfirmBox == null) {
            statusDialogStart(eventData);
        }
        diyConfirmBox.find('.use-case-confirmation-step-preparing').removeClass('working').show();
        diyConfirmBox.find('.use-case-confirmation-step-import').removeClass('working').show();
        diyConfirmBox.find('.use-case-confirmation-step-publishing').removeClass('working').show();
        diyConfirmBox.find('.use-case-confirmation-step-preparing-finished').hide();
        diyConfirmBox.find('.use-case-confirmation-step-import-finished').hide();

        diyConfirmBox.find('.pe-dialog-box-title').html(jimdoData.messages.pagesEditor.dialogBox.autosaveFailedTitle);
        diyConfirmBox.find('.pe-dialog-box-description').html(jimdoData.messages.pagesEditor.dialogBox.autosaveFailedDescription);

        diyConfirmBox.find('.pe-window-loading').hide();

        diyConfirmBox.diy_confirmationDialog({
            closeOnEscape: false,
            overlayCls: null, /* use default semi-transparent overlay */
            buttons: [
                diyConfirmBoxButtons.okButton
            ]
        });
    };

    var statusDialogAutoSaveError = function ()
    {
        releaseConfirmBox();
        diyConfirmBox = jQuery(confirmBoxHtml);

        diyConfirmBox.find('.pe-dialog-box-title').html(jimdoData.messages.pagesEditor.dialogBox.autosaveFailedTitle);
        diyConfirmBox.find('.pe-dialog-box-description').html(jimdoData.messages.pagesEditor.dialogBox.autosaveFailedDescription);
        diyConfirmBox.diy_confirmationDialog({
            zIndex: 100210,
            width: 386,
            overlayCls: null, /* use default semi-transparent overlay */
            position: {
                my: 'center middle',
                at: 'center middle'
            },
            buttons: [
                diyConfirmBoxButtons.okButton
            ]
        });
    };

    var updateLoadingStatus = function(eventData)
    {

        switch (eventData.action) {

            case 'use_case_start':
                statusDialogStart(eventData);
                diy.editor.siteadmin.api.smallLoading(true);
                break;
            case 'simple_start':
                diy.editor.siteadmin.api.smallLoading(true);
                break;
            case 'use_case_finished':
                releaseConfirmBox();

                localMainScope.$apply(function () {
                    localMainScope.$broadcast('usecaseAdded', eventData.websiteUseCaseId);
                    jQuery(document).trigger('diy-managepages-page-added');
                });

                diy.editor.siteadmin.api.smallLoading(false);
                break;
            case 'simple_end':
                diy.editor.siteadmin.api.smallLoading(false);
                break;
            case 'use_case_importing':
                statusDialogImporting(eventData);
                break;
            case 'use_case_imported':
                statusDialogImported(eventData);
                break;
            case 'use_case_error':
                statusDialogError(eventData);
                diy.editor.siteadmin.api.smallLoading(false);
                break;
            case 'autosave_error':
                statusDialogAutoSaveError();
                break;
            case 'get_data_error':
                localMainScope.$apply(function () {
                    if (eventData.dataType == 'navigationData'
                        || eventData.dataType == 'usecasesData'
                        || eventData.dataType == 'pageDetailsData'
                        ) {
                        localMainScope.$broadcast('showMajorError', eventData.dataType, {
                            type: 'error',
                            // text: jimdoData.messages.pagesEditor.errors[eventData.dataType],
                            text: jimdoData.messages.pagesEditor.errors['default'],
                            icon: true
                        });
                    }
                });
                break;
        }
    };

    this.hide = function()
    {
        if (this.isHidden) {
            return;
        }
        this.isHidden = true;
        var $overlay = jQuery('#siteadmin-window-overlay-pagesEditor');
        $overlay.unbind('click');
        diy.editor.navigation.api.updateJimdoData(function(data){
            diy.editor.navigation.api.verifyCurrentPage(data, function(){
                // the current page still exists, but:...
                // ..."is it now homepage?" or "is it no longer the homepage"
                var currentPageNewIndex = diy.editor.navigation.api.getPageIndex(
                    getCurrentPageId()
                );
                if (currentPageStartIndex != currentPageNewIndex
                    && (currentPageStartIndex == 0 || currentPageNewIndex == 0)
                ) {
                    window.location.reload();
                    return;
                }
                $overlay.remove();
                if(diy.editor.undoRedo) {
                    // this will be moved when sending data to server; in pages individual changes
                    diy.editor.undoRedo.closeActiveSession();
                    // should call signalEntryCreatedOnServerSide, but in individual changes
                    diy.editor.undoRedo.requestServerSync();
                }
                // broadcast that the SA window is hiding //
                localMainScope.$broadcast('windowHide');
            });
        });

    };

    this.allowSwitch = function()
    {
        if (diyConfirmBox != null) {
            return false;
        }

        return this.controllerLoaded;
    };

    return this;

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/controllers/pagesEditor.js
 ** module id = 796
 ** module chunks = 0
 **/